import { useEffect } from 'react'

const SEO = ({
  title = "Naguib Heiba - Software Engineer & Digital Health Researcher",
  description = "PhD researcher at RWTH Aachen and Fraunhofer FIT specializing in digital health, eHealth solutions, and web development. Expert in React, Node.js, HL7 FHIR, and healthcare standards.",
  keywords = "digital health, software engineer, PhD researcher, RWTH Aachen, eHealth, HL7 FHIR, React developer, healthcare technology, web development",
  image = "https://media.licdn.com/dms/image/v2/C4D03AQEaGWB1X7FSpA/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1636034994681?e=1753920000&v=beta&t=EyZyRg5LQ2czSyM5U-isTHMafDcEkF2kAULcsu2qzDk",
  url = "https://www.naguib-heiba.com",
  type = "website"
}) => {
  useEffect(() => {
    // Set page title
    document.title = title

    // Helper to set or update meta tags
    const setMeta = (name, content, isProperty = false) => {
      const attribute = isProperty ? 'property' : 'name'
      const selector = `meta[${attribute}="${name}"]`
      
      let meta = document.querySelector(selector)
      if (!meta) {
        meta = document.createElement('meta')
        meta.setAttribute(attribute, name)
        document.head.appendChild(meta)
      }
      meta.setAttribute('content', content)
    }

    // Basic meta tags
    setMeta('description', description)
    setMeta('keywords', keywords)

    // Open Graph
    setMeta('og:title', title, true)
    setMeta('og:description', description, true)
    setMeta('og:image', image, true)
    setMeta('og:url', url, true)
    setMeta('og:type', type, true)

    // Twitter
    setMeta('twitter:title', title)
    setMeta('twitter:description', description)
    setMeta('twitter:image', image)
    setMeta('twitter:card', 'summary_large_image')

    // Canonical link
    let canonical = document.querySelector('link[rel="canonical"]')
    if (!canonical) {
      canonical = document.createElement('link')
      canonical.rel = 'canonical'
      document.head.appendChild(canonical)
    }
    canonical.href = url

  }, [title, description, keywords, image, url, type])

  return null
}

export default SEO